import { OptionsMeta } from 'models/MetaData/metaData.model';
import * as Yup from 'yup';

const yearFormValidationSchema = (existingYears: OptionsMeta[]) => {
  return Yup.object().shape({
    year: Yup.string()
      .typeError('Field is required')
      .required('Year is required')
      .test(
        'unique-year',
        'Organization Map already exists for the selected year',
        function (value) {
          if (existingYears.length === 0) {
            return true;
          }
          return !existingYears.some(year => year.value == value);
        }
      ),
  });
};

export default yearFormValidationSchema;
